import styled from "styled-components";
import theme from "../../styles/theme";

export const Container = styled.div`
  padding: 20px;
  width: 100%;
  overflow-y: auto;
  height: 100vh;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h1 {
    font-size: 24px;
    color: ${theme.primaryColor};
    margin: 0;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const ContainerCards = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;
`;

export const CardTreinamento = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 300px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .rs-theme-dark & {
    background: ${theme.darkGray};
  }
`;

export const CardInfo = styled.div`
  flex: 1;

  h3 {
    margin: 0 0 4px 0;
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 250px; 

    .rs-theme-dark & {
      color: #fff;
    }
  }

  .slug {
    font-size: 12px;
    color: #666;
    margin-bottom: 8px;

    .rs-theme-dark & {
      color: #aaa;
    }
  }

  .meta {
    display: flex;
    gap: 16px;
    font-size: 13px;
    color: #888;
  }
`;

export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const StatusBadge = styled.span`
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${(props) => {
    switch (props.variant) {
      case "ativo":
        return "#4caf50";
      case "inativo":
        return "#9e9e9e";
      case "aula":
        return "#2196f3";
      case "quiz":
        return "#9c27b0";
      default:
        return "#9e9e9e";
    }
  }};
  color: #fff;
`;

export const Container2 = styled.div`
width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

// export const PageContainer = styled.div`
//   flex-grow: 1;
//   overflow: auto;
// `;

export const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
`;

export const Sidebar = styled.div`
  width: 220px;
  background: #f5f5f5;
  border-right: 1px solid #e0e0e0;
  padding: 20px 0;
  flex-shrink: 0;

  .rs-theme-dark & {
    background: ${theme.darkGray};
    border-color: #444;
  }
`;

export const SidebarItem = styled.div`
  padding: 12px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => (props.active ? theme.primaryColor : "#666")};
  background: ${(props) =>
    props.active ? "rgba(59, 130, 246, 0.1)" : "transparent"};
  border-left: 3px solid
    ${(props) => (props.active ? theme.primaryColor : "transparent")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  transition: all 0.2s;

  &:hover {
    background: rgba(59, 130, 246, 0.05);
  }

  .rs-theme-dark & {
    color: ${(props) => (props.active ? theme.primaryColor : "#ccc")};
  }

  span {
    font-size: 14px;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 20px 30px;
  overflow-y: auto;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${theme.primaryColor};
    cursor: pointer;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  margin-bottom: 24px;

  .link-button {
    color: ${theme.primaryColor};
    background: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
    font: inherit;

    &:hover {
      text-decoration: underline;
    }
  }

  span {
    color: #999;
  }

  .rs-theme-dark & {
    color: #aaa;
  }
`;

export const Section = styled.div`
  margin-bottom: 32px;

  h2 {
    font-size: 18px;
    margin-bottom: 16px;
    color: #333;

    .rs-theme-dark & {
      color: #fff;
    }
  }
`;

export const ModulesLinkCard = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(
    135deg,
    ${theme.primaryColor}15 0%,
    ${theme.primaryColor}08 100%
  );
  border: 1px solid ${theme.primaryColor}40;
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${theme.primaryColor};
    box-shadow: 0 4px 12px ${theme.primaryColor}20;
    transform: translateY(-2px);
  }

  .rs-theme-dark & {
    background: linear-gradient(
      135deg,
      ${theme.primaryColor}20 0%,
      ${theme.primaryColor}10 100%
    );
    border-color: ${theme.primaryColor}50;
  }

  .icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: ${theme.primaryColor};
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .info {
    flex: 1;

    h4 {
      margin: 0 0 4px 0;
      font-size: 16px;
      font-weight: 600;
      color: #333;

      .rs-theme-dark & {
        color: #fff;
      }
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #666;

      .rs-theme-dark & {
        color: #aaa;
      }
    }
  }

  .arrow {
    color: ${theme.primaryColor};
    flex-shrink: 0;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 8px;
    color: #333;

    .rs-theme-dark & {
      color: #ccc;
    }
  }

  .hint {
    font-size: 12px;
    color: #888;
    margin-top: 4px;
  }

  .error {
    font-size: 12px;
    color: #f44336;
    margin-top: 4px;
  }
`;

export const ModuleCard = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 12px;

  .rs-theme-dark & {
    background: ${theme.darkGray};
    border-color: #444;
  }

  .drag-handle {
    cursor: grab;
    color: #999;
    padding: 4px;

    &:active {
      cursor: grabbing;
    }
  }

  .module-info {
    flex: 1;

    h4 {
      margin: 0 0 4px 0;
      font-size: 15px;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .module-meta {
      font-size: 13px;
      color: #888;
    }
  }

  .module-actions {
    display: flex;
    gap: 8px;
  }
`;

export const BlockEditor = styled.div`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  .rs-theme-dark & {
    background: ${theme.darkGray};
    border-color: #444;
  }

  .block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .block-type {
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      color: ${theme.primaryColor};
    }
  }
`;

export const QuestionCard = styled.div`
  background: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  .rs-theme-dark & {
    background: #2a2a2a;
    border-color: #444;
  }

  .question-header {
    font-weight: 500;
    margin-bottom: 12px;
  }

  .alternatives {
    margin-left: 16px;

    .alternative {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 0;
      font-size: 14px;

      &.correct {
        color: #4caf50;
        font-weight: 500;
      }
    }
  }

  .question-meta {
    margin-top: 12px;
    font-size: 12px;
    color: #888;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #888;

  svg {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h3 {
    font-size: 18px;
    margin-bottom: 8px;
    color: #666;

    .rs-theme-dark & {
      color: #aaa;
    }
  }

  p {
    font-size: 14px;
    margin-bottom: 16px;
  }
`;

export const AddBlockButton = styled.button`
  width: 100%;
  padding: 16px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background: transparent;
  color: #888;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: ${theme.primaryColor};
    color: ${theme.primaryColor};
  }
`;

export const ModalContent = styled.div`
  padding: 10px 0;

  .type-selector {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
  }

  .type-option {
    flex: 1;
    padding: 20px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: ${theme.primaryColor};
    }

    &.selected {
      border-color: ${theme.primaryColor};
      background: rgba(59, 130, 246, 0.05);
    }

    .icon {
      font-size: 32px;
      margin-bottom: 8px;
    }

    .label {
      font-weight: 500;
    }
  }
`;

export const QuestionSelectorList = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  .rs-theme-dark & {
    border-color: #444;
  }

  .question-item {
    padding: 12px 16px;
    border-bottom: 1px solid #e0e0e0;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 12px;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }

    &.selected {
      background: rgba(59, 130, 246, 0.1);
    }

    .rs-theme-dark & {
      border-color: #444;

      &:hover {
        background: #333;
      }
    }

    .question-text {
      flex: 1;

      .enunciado {
        font-weight: 500;
        margin-bottom: 4px;
      }

      .meta {
        font-size: 12px;
        color: #888;
      }
    }
  }
`;

export const RichTextWrapper = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;

  .rs-theme-dark & {
    border-color: #444;
  }

  .toolbar {
    display: flex;
    gap: 4px;
    padding: 8px;
    background: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
    flex-wrap: wrap;

    .rs-theme-dark & {
      background: #333;
      border-color: #444;
    }

    button {
      padding: 6px 10px;
      border: none;
      background: transparent;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: #e0e0e0;
      }

      &.active {
        background: ${theme.primaryColor};
        color: #fff;
      }

      .rs-theme-dark &:hover {
        background: #444;
      }
    }
  }

  .editor-content {
    min-height: 200px;
    padding: 16px;

    &:focus {
      outline: none;
    }
  }
`;

export const AlternativeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  margin-bottom: 8px;
  background: #f9f9f9;
  border-radius: 6px;

  .rs-theme-dark & {
    background: #2a2a2a;
  }

  .drag-handle {
    cursor: grab;
    color: #999;
    padding: 4px;
  }

  input[type="text"] {
    flex: 1;
  }

  .correct-indicator {
    color: #4caf50;
    font-weight: 600;
  }
`;

export const PreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f0f0f0;
  min-height: 100%;

  .rs-theme-dark & {
    background: #1a1a1a;
  }
`;

export const PhoneFrame = styled.div`
  width: 375px;
  height: 700px;
  background: #fff;
  border-radius: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .phone-header {
    background: ${theme.primaryColor};
    color: #fff;
    padding: 40px 20px 20px;
    text-align: center;

    h3 {
      margin: 0;
      font-size: 18px;
    }
  }

  .phone-content {
    flex: 1;
    overflow-y: auto;
    padding: 20px;

    h2 {
      font-size: 16px;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 16px;
    }
  }

  .phone-footer {
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    text-align: center;
  }
`;
